import {
  CombinationsValidationPageRequest,
  ValidateCombinationsDTO,
} from '../../../../services/modules/productDetails/productDetails.types';
import { ProductDetailsDTO } from '../types/productDetails.types';
import { toCombinationKey } from './combinationKey.utils';

export const buildPerPageRequests = (
  pages: { data?: ProductDetailsDTO[] }[],
): CombinationsValidationPageRequest[] =>
  pages.reduce<CombinationsValidationPageRequest[]>((requests, page) => {
    const pageData = page.data ?? [];
    if (!pageData.length) {
      return requests;
    }

    const orderIds = new Set<string>();
    const combinations: CombinationsValidationPageRequest['combinations'] = [];

    for (const combination of pageData) {
      if (combination.orderId) {
        orderIds.add(combination.orderId);
      }
      combinations.push(toCombinationKey(combination));
    }

    requests.push({ orderIds: Array.from(orderIds), combinations });

    return requests;
  }, []);

export const mergeOrdersErrors = (
  pages: ValidateCombinationsDTO[],
): ValidateCombinationsDTO['ordersErrors'] =>
  pages.reduce<ValidateCombinationsDTO['ordersErrors']>(
    (merged, page) =>
      Object.entries(page.ordersErrors).reduce((acc, [orderId, orderErrors]) => {
        const existing = acc[orderId] ?? {
          combinationsWithErrors: {},
        };
        acc[orderId] = {
          combinationsWithErrors: {
            ...existing.combinationsWithErrors,
            ...orderErrors.combinationsWithErrors,
          },
        };

        return acc;
      }, merged),
    {},
  );
